import { render } from "./TvmStartUpButtons.vue?vue&type=template&id=8a574928&scoped=true"
import script from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"
export * from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"

import "./TvmStartUpButtons.vue?vue&type=style&index=0&id=8a574928&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a574928"],['__file',"src/components/ChatWidget/TvmStartUpButtons/TvmStartUpButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a574928"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a574928', __exports__)) {
    api.reload('8a574928', __exports__)
  }
  
  module.hot.accept("./TvmStartUpButtons.vue?vue&type=template&id=8a574928&scoped=true", () => {
    api.rerender('8a574928', render)
  })

}


export default __exports__